import { render, staticRenderFns } from "./index.vue?vue&type=template&id=732d452e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=732d452e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d452e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732d452e')) {
      api.createRecord('732d452e', component.options)
    } else {
      api.reload('732d452e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=732d452e&scoped=true&", function () {
      api.rerender('732d452e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/department/compoments/Hr/index.vue"
export default component.exports